const SEOHead = ({
  title = "Venury | AI-Augmented Product Development",
  description = "Venury — AI-augmented development studio building products for funded startups. Full-stack development, AI integration, cloud infrastructure. 8-16 week delivery.",
  url = "https://venury.tech",
  type = "website",
}) => (
  <>
    <title>{String(title)}</title>
    <meta name="description" content={String(description)} />
    <link rel="canonical" href={String(url)} />
    <meta property="og:title" content={String(title)} />
    <meta property="og:description" content={String(description)} />
    <meta property="og:type" content={type} />
    <meta property="og:url" content={url} />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
  </>
);

export default SEOHead;
